import { omit } from 'lodash';

const getData = (state) => {
  if (!state.data) {
    return {};
  }

  return omit(state.data, ['agreements', 'multipleDisclosures']);
};

export default getData;
